











import Vue from 'vue';
import { openModal } from 'mycorems-app-shared';
import AccountType from './AccountType';
import isGranted from '../auth/isGranted';
import NewAgencyModal from './NewAccountModal.vue';
import { Account } from '../types';

export default Vue.extend({
  props: {
    parentId: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
  },
  computed: {
    canView(): boolean {
      if (this.type === AccountType.CLIENT) {
        return isGranted('VIEW_CLIENTS');
      }
      if (this.type === AccountType.AGENCY) {
        return isGranted('VIEW_AGENCIES');
      }
      return false;
    },
    label(): string {
      if (this.type === AccountType.AGENCY) {
        return 'New Agency';
      }
      if (this.type === AccountType.CLIENT) {
        return 'New Client';
      }
      return 'New Account';
    },
  },
  methods: {
    open(): void {
      openModal(NewAgencyModal, {
        parentId: this.parentId,
        type: this.type,
        label: this.label,
      }).onOk((account: Account) => {
        this.$emit('created', account);
      });
    },
    isGranted,
  },
});
